<mat-card>
  <mat-card-header class="title-card-header">
    <mat-icon (click)="returnToDashboard()" style="cursor: pointer">arrow_back</mat-icon>
    <h2>Contratos</h2>
  </mat-card-header>
  <mat-card-content>
    <table mat-table [dataSource]="dataSourceContractList">
      <ng-container matColumnDef="GEN_CONTRATO">
        <th mat-header-cell *matHeaderCellDef>Contrato</th>
        <td mat-cell *matCellDef="let element">{{element.GEN_CONTRATO}} </td>
      </ng-container>
      <ng-container matColumnDef="DESCRICAO">
        <th mat-header-cell *matHeaderCellDef>Box</th>
        <td mat-cell *matCellDef="let element">{{element.DESCRICAO}} </td>
      </ng-container>
      <ng-container matColumnDef="DESCRICAO_LOJA">
        <th mat-header-cell *matHeaderCellDef>Unidade</th>
        <td mat-cell *matCellDef="let element">{{element.DESCRICAO_LOJA}} </td>
      </ng-container>
      <ng-container matColumnDef="VALOR_BASE">
        <th mat-header-cell *matHeaderCellDef>Valor base</th>
        <td mat-cell *matCellDef="let element">{{element.VALOR_BASE | currency: 'BRL'}} </td>
      </ng-container>
      <ng-container matColumnDef="DATA_LOCACAO">
        <th mat-header-cell *matHeaderCellDef>Início do contrato</th>
        <td mat-cell *matCellDef="let element">{{element.DATA_LOCACAO | date}} </td>
      </ng-container>
      <ng-container matColumnDef="FINALIZAR_CONTRATO_DATA">
        <th mat-header-cell *matHeaderCellDef>Encerramento do contrato</th>
        <td mat-cell *matCellDef="let element">{{(element.DATA_FINALIZAR | date) || '(Contrato em vigor)'}} </td>
      </ng-container>
      <ng-container matColumnDef="INADIMPLENCIA">
        <th mat-header-cell *matHeaderCellDef>Status financeiro</th>
        <td mat-cell *matCellDef="let element"> {{element.INADIMPLENCIA ? 'Inadimplente' : 'Em dia'}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsContracts"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsContracts;" (click)="openContract(row.GEN_CONTRATO)"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="3">Nenhum contrato encontrado</td>
      </tr>
    </table>
  </mat-card-content>
</mat-card>
